import "./NewsPage.css";
import Navbar from "../../components/Navbar";
import NewsPreview from "./NewsPreview";
import Footer from "../../components/Footer";
import Introduction from "../../components/Introduction.js";
import Pagination from "../../components/Pagination";
import DefaultPage from "../DefaultPage/DefaultPage.js";
import useFetch from "../../hooks/useFetch";
import config from "../../config";
import { useState } from "react";
import Loader from "../../components/Loader.js";

const NewsPage = () => {
  //stav pro strankovani
  const [pageIndex, setPageIndex] = useState(1);

  //fetch úvodu
  const {
    loading: loadingIntroduction,
    error: errorIntroduction,
    data: dataIntroduction,
  } = useFetch(`${config.api}/api/news-page?populate=background`);

  //fetch aktualit, nastaveni ovladani strankovani stavem pageIndex, maximum aktualit na strance hodnota [pageSize]
  const { loading, error, data } = useFetch(
    `${config.api}/api/news?populate[0]=image&sort[1]=date:desc&pagination[page]=${pageIndex}&pagination[pageSize]=9`
  );

  // možné stavy při/po fetchi
  if (loadingIntroduction) return <Loader />;
  if (errorIntroduction)
    return <DefaultPage message="Chyba při načítání úvodu" />;
  if (!dataIntroduction || !dataIntroduction.data)
    return <DefaultPage message="Chyba při načítání úvodu" />;

  if (loading) return <Loader />;
  if (error) return <DefaultPage message="Chyba při načítání dokumentů" />;

  if (!data || !data.data || data.data.length === 0)
    return <DefaultPage message="Žádné aktuality" />;

  //? test
  //?console.log("Aktuality", data);

  //metoda pro zmenu stranky
  const handlePageChange = (index) => {
    setPageIndex(index);
  };

  //změna titulku stránky v prohlížeči
  document.title = dataIntroduction.data.title;

  return (
    <div>
      <Navbar />
      <Introduction
        title={dataIntroduction.data.title}
        text={dataIntroduction.data.description}
        image={dataIntroduction.data.background.url}
      />
      <div className="container-fluid background-white">
        <div className="container container-background">
          <div className="row d-flex justify-content-center pt-4">
            {data.data.map((news) => (
              <NewsPreview
                key={news.id}
                id={news.documentId}
                alt={news.image.alternativeText}
                name={news.name}
                image={`${config.api}${news.image.url}`}
                date={news.date}
                overview={news.overview}
              />
            ))}
          </div>

          {/* tlacitka next a previous */}
          {/* <div className="d-flex justify-content-center">
        <button
          disabled={pageIndex === 1}
          onClick={() => setPageIndex(pageIndex - 1)}
        >
          Previous
        </button>
        <button
          disabled={pageIndex === (data && data.meta.pagination.pageCount)}
          onClick={() => setPageIndex(pageIndex + 1)}
        >
          Next
        </button>
      </div> */}

          {/* komponenta strankovani (cisla stranek) */}
          <div className="d-flex justify-content-center pb-4">
            <Pagination
              pageCount={data.meta.pagination.pageCount}
              currentPage={pageIndex}
              onPageChange={handlePageChange}
            />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
export default NewsPage;

